module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDEwIDE3Ij4KICA8cG9seWdvbiBmaWxsPSIjMDAwMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHBvaW50cz0iODc1LjI3OCA4MTUuNSA4NjcuNSA4MjMuMjc4IDg2Ni4yMzkgODIyLjAxNyA4NzIuNzU2IDgxNS41IDg2Ni4yMzkgODA4Ljk4MyA4NjcuNSA4MDcuNzIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODY2IC04MDcpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-right.svg
// module id = 608
// module chunks = 168707334958949